{
  "_provenance": {
    "ns": "memorial",
    "source": "the bereavement register: lib/{dashboard-mode,bereavement-tone}.ts — every key is reviewed by a person before it ships (R3-B7; #644, #693) (#2109 R3 lane L1)"
  },
  "hero": {
    "eyebrow": "In memory",
    "lede": "Always part of your family.",
    "titleFallback": "Your child"
  }
}
